export default __webpack_public_path__ + "static/media/arrowDown.55ea55ec.svg";